<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card class="pa-3">
          <l-data-table
          :headers="header"
          :get-data-func="getConfigList"
          title-text="分组详情配置列表"></l-data-table>
          <l-fixed-btn
            @click="addConfig"
            icon="$vuetify.icons.add"
          ></l-fixed-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </l-layout>
</template>
<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
export default {
  components: {LDataTable},
  data () {
    return {
      header: [
        {text: '分组名称', value: 'name', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: false}
      ]
    }
  },
  methods: {
    async getConfigList () {
      return {amount: 0, items: []}
    },
    addConfig () {
      this.$router.push(
        {
          name: 'extraConfig',
          query: {
            status: 'new'
          }
        })
    }
  }
}
</script>
